import { Typography } from 'beek-design-system';
import { useTranslations } from 'next-intl';
import Alphabet from 'src/components/AudioBooksSiteMap/Alphabet';
import styled from 'styled-components';

const MainWrapper = styled.div`
  margin-top: 5rem;
  padding: 0rem 1rem;
  @media ${({ theme }): string => theme.devices.laptop} {
    padding: 0rem;
    display: block;
    width: 57.3125rem;
    height: 5.25rem;
    margin: 0 auto;
  }
`;

const IndexWrappers = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const LettersIndex = (): JSX.Element => {
  const t = useTranslations('audioContent');
  return (
    <MainWrapper>
      <Typography
        type="headline3"
        marginBottom="2rem"
        data-cy="letters-index-title"
      >
        {`${t('letterIndex')}`}
      </Typography>
      <IndexWrappers>
        <Alphabet type="bookPage" />
      </IndexWrappers>
    </MainWrapper>
  );
};

export default LettersIndex;
